/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { OrderDetailsSummary } from 'shared-ui/components/OrderDetailsLayout';
import DetailSummary from './DetailSummary';

function OrderSummary({
    imageUrl,
    proceedToCartButtonText,
    isLoading,
    isWaitingForServerResponse,
    isExistingReservation,
    isProceedToCartDisabled,
    hasPendingModification,
    secondaryButtonIsDisabled,
    isDrawerWrapFullWidth,
    showSitePasses,
    date,
    endDate,
    startTime,
    endTime,
    validDays,
    onProceedToCartClick,
    onRemoveClick,
    onContinueShopping,
    showBuyNow,
    reservationId,
}) {
    const orderDetails = useSelector((state) => state?.timedEntry?.orderDetails);

    const { tour_name: tourName, facility_name: facilityName } = orderDetails;

    return (
        <OrderDetailsSummary
            isLoading={isLoading}
            heading={tourName}
            imageUrl={imageUrl}
            isWaitingForServerResponse={isWaitingForServerResponse}
            parentName={facilityName}
            isExistingReservation={isExistingReservation}
            hasPendingModification={hasPendingModification}
            isProceedToCartDisabled={isProceedToCartDisabled}
            showSitePasses={showSitePasses}
            date={date}
            endDate={endDate}
            startTime={startTime}
            endTime={endTime}
            validDays={validDays}
            onProceedToCartClick={onProceedToCartClick}
            proceedToCartButtonText={proceedToCartButtonText}
            secondaryButtonText={isExistingReservation ? 'Cancel' : 'Continue Shopping'}
            onSecondaryButtonClick={() => {
                if (isExistingReservation) {
                    onRemoveClick();
                } else {
                    onContinueShopping();
                }
            }}
            secondaryButtonIsDisabled={secondaryButtonIsDisabled}
            isDrawerWrapFullWidth={isDrawerWrapFullWidth}
            showBuyNow={showBuyNow}
            reservationId={reservationId}
        >
            <DetailSummary
                isExistingReservation={isExistingReservation}
                showSitePasses={showSitePasses}
                validDays={validDays}
                date={date}
                endDate={endDate}
                startTime={startTime}
                endTime={endTime}
            />
        </OrderDetailsSummary>
    );
}

OrderSummary.propTypes = {
    imageUrl: PropTypes.string,
    proceedToCartButtonText: PropTypes.string,
    isLoading: PropTypes.bool,
    isWaitingForServerResponse: PropTypes.bool,
    isExistingReservation: PropTypes.bool,
    isProceedToCartDisabled: PropTypes.bool,
    hasPendingModification: PropTypes.bool,
    secondaryButtonIsDisabled: PropTypes.bool,
    isDrawerWrapFullWidth: PropTypes.bool,
    showSitePasses: PropTypes.bool,
    date: PropTypes.string,
    endDate: PropTypes.string,
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    validDays: PropTypes.number,
    onProceedToCartClick: PropTypes.func,
    onRemoveClick: PropTypes.func,
    onContinueShopping: PropTypes.func,
    showBuyNow: PropTypes.bool,
    reservationId: PropTypes.string,
};

OrderSummary.defaultProps = {
    showSitePasses: false,
    validDays: 0,
    onContinueShopping: () => {},
};

export default OrderSummary;
